// Lightweight reCAPTCHA v3 helper. Loads the script once, caches the ready promise,
// and exposes executeRecaptcha(action) to get a token.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.grecaptcha && window.grecaptcha.execute) return resolve(true);
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => resolve(true));
      } else {
        resolve(false);
      }
    };
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export async function executeRecaptcha(action = "submit") {
  if (!SITE_KEY) return { token: "", action };
  const ready = await loadScript();
  if (!ready || !window.grecaptcha?.execute) return { token: "", action };
  try {
    const token = await window.grecaptcha.execute(SITE_KEY, { action });
    return { token, action };
  } catch {
    return { token: "", action };
  }
}

// Hide the default reCAPTCHA badge (we render our own "protected by" text to comply with TOS)
export function installRecaptchaBadgeCSS() {
  if (typeof document === "undefined") return;
  if (document.getElementById("recaptcha-badge-hide")) return;
  const css = document.createElement("style");
  css.id = "recaptcha-badge-hide";
  css.innerHTML = ".grecaptcha-badge { visibility: hidden !important; }";
  document.head.appendChild(css);
}

export const RECAPTCHA_ENABLED = !!SITE_KEY;
